<ngb-timepicker highlight-on-click
                [(ngModel)]="value"
                [spinners]="false"
                [meridian]="true"
                [disabled]="disabled || readonly"
                (keydown)="toggleTimeMeridian($event)">
</ngb-timepicker>
